import { Tile as TileLayer, Group as LayerGroup} from 'ol/layer';
import { XYZ as XYZSource } from 'ol/source';

const sources:any = {
    normal: {
        map: "http://t{0-7}.tianditu.com/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk={key}",
        annotation:  "http://t{0-7}.tianditu.com/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk={key}",
        attributions:["天地图"]
    }
}

const tdt = (token: string, type: string = "normal") =>{
    let typeInfo = sources[type];
    let mapLayer = new TileLayer({
        source: new XYZSource({
            url: typeInfo.map.replace("{key}", token),
            attributions: typeInfo.attributions
        }),
    });
    let annotationLayer = new TileLayer({
        source: new XYZSource({
            url: typeInfo.annotation.replace("{key}", token),
            attributions: typeInfo.attributions
        })
    });

    return new LayerGroup({
        layers: [
            mapLayer, annotationLayer
        ]
    });
}


export default tdt;